var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"ma-0 pa-0"},[_c('v-col',{attrs:{"cols":"12"}},[_c('GChart',{attrs:{"type":"LineChart","options":_vm.options,"data":_vm.data}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }